export const iconFontAwesomePunctuationSymbolsEquals = (
	<i className="fa-solid fa-equals"></i>
);
